/**
 * Live agent status — polls every 3s per v1 MVP.
 *
 * Once the multiplexed WS event bus is wired up (§8.6), `useEventStream`
 * will push `status` topic updates into the query cache and this hook
 * can drop to a longer poll or become purely push-based.
 */
import { useQuery } from '@tanstack/react-query';
import { agentsApi } from '@/api/agents';

export function useAgentStatus(name: string | undefined, enabled = true) {
  return useQuery({
    queryKey: ['agent', name, 'status'],
    queryFn: () => agentsApi.status(name!),
    enabled: !!name && enabled,
    refetchInterval: 3_000,
    refetchIntervalInBackground: false,
  });
}
